import { combineReducers } from 'redux';
import { StreamsState } from 'streamsState/store/StreamsState';
import { streamedDataReducer } from 'streamsState/store/streamedData/reducer';
import { streamStatusesReducer } from 'streamsState/store/streamStatuses/reducer';

export const streamsReducer = combineReducers<StreamsState>({
    data: streamedDataReducer,
    statuses: streamStatusesReducer,
});
